import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { toast } from "react-toastify";

import Input from '../../shared/components/FormElements/Input';
import Button from '../../shared/components/FormElements/Button';
import {
  VALIDATOR_REQUIRE,
  //VALIDATOR_MINLENGTH
} from '../../shared/util/validators';
import { useForm } from '../../shared/hooks/form-hook';
import { useHttpClient } from '../../shared/hooks/http-hook';
//import './FileForm.css';
// import footer
import Footer from '../../shared/components/UIElements/Footer';

const EnterCodeForm = () => {
  //const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const { sendRequest } = useHttpClient();

  // ADD THIS
  const [isVerifying, setIsVerifying] = useState(false);

  const [formState, inputHandler] = useForm(
    {
      otp: {
        value: '',
        isValid: false
      },
    },
    false
  );
  const history = useHistory();

  const otpSubmitHandler = async event => {
    event.preventDefault();

    if (isVerifying) return;
    setIsVerifying(true);

    // Loading toast
    const toastId = toast.loading("Verifying OTP...", {
      position: "top-center"
    });

    try {
      const responseData = await sendRequest(
        process.env.REACT_APP_BACKEND_URL + '/users/verify-otp',
        'POST',
        JSON.stringify({
          otp: formState.inputs.otp.value
        }),
        {
          'Content-Type': 'application/json',
        }
      );
      //console.log(responseData);
      //console.log(responseData.success);
    
      // Success
      toast.update(toastId, {
        render: "OTP verified successfully",
        type: "success",
        isLoading: false,
        autoClose: 3000
      });

      localStorage.setItem('sharedToken', responseData.sharedToken);
      history.push('/shared/files');
      
    } catch (err) {
      // Error
      toast.update(toastId, {
        render: "Verify OTP failed",
        type: "error",
        isLoading: false,
        autoClose: 3000
      });
    } finally {
      setIsVerifying(false);
    }

  };

  return (
    <React.Fragment>
      <form className="place-form" onSubmit={otpSubmitHandler}>
        <Input
          id="otp"
          element="input"
          type="text"
          inputMode="numeric"
          maxLength={4}
          label="Enter 4 digit code:"
          validators={[VALIDATOR_REQUIRE()]}
          errorText="Please enter a valid code."
          onInput={inputHandler}
          //autoFocus
        />

        <Button type="submit" disabled={!formState.isValid || isVerifying }>
          {isVerifying ? "Verifying..." : "Submit"}
        </Button>
      </form>
      {/* Footer */}
      <Footer />
    </React.Fragment>
  );
};

export default EnterCodeForm;

